var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recharge-delivery"},[_c('market-title',{attrs:{"iconClass":'iconchongzhisong',"title":'充值送',"des":'支持店铺会员充值赠送余额，引导消费者储值'}}),_c('recharge-delivery-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }